import { App } from './app.class';
import { CountUp } from 'countup.js';
import { Notification } from './notification.class';
import ClipboardJS from 'clipboard';

export class Page {

    constructor() {

        // Chart der Sendungen
        const $chart_submissions = document.querySelector("#chart-submissions");
        if($chart_submissions) {
            let months_list = $chart_submissions.dataset?.monthsList;
            if(months_list) {
                months_list = months_list.split(',');
            }
            let months_subcounts = $chart_submissions.dataset?.monthsSubcounts;
            if(months_subcounts) months_subcounts = months_subcounts.split(',').map(num => parseInt(num));
            const locale_submissions = $chart_submissions.dataset?.localeSubmissions;
            const locales = [{
                "name": "en",
                "options": {
                    "months": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                    "shortMonths": ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                    "days": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                    "shortDays": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                    "toolbar": {
                        "exportToSVG": "Download SVG",
                        "exportToPNG": "Download PNG",
                        "menu": "Menu",
                        "selection": "Selection",
                        "selectionZoom": "Selection Zoom",
                        "zoomIn": "Zoom In",
                        "zoomOut": "Zoom Out",
                        "pan": "Panning",
                        "reset": "Reset Zoom"
                    }
                }
            },{
                "name": "de",
                "options": {
                    "months": ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
                    "shortMonths": ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
                    "days": ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
                    "shortDays": ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
                    "toolbar": {
                        "exportToSVG": "SVG herunterladen",
                        "exportToPNG": "PNG herunterladen",
                        "menu": "Menü",
                        "selection": "Auswahl",
                        "selectionZoom": "Auswahl-Zoom",
                        "zoomIn": "Vergrößern",
                        "zoomOut": "Verkleinern",
                        "pan": "Verschieben",
                        "reset": "Zoom zurücksetzen"
                    }
                }
            }];
            if(months_list && months_subcounts) {
                const options = {
                    chart: {
                        type: 'line',
                        animations: {
                            enabled: true,
                            speed  : 800
                        },
                        toolbar: {
                            show: false
                        },
                        foreColor: '#6B7280',
                        height: 230,
                        zoom: {
                            enabled: false
                        },
                        locales: locales,
                        defaultLocale: App.getLang()
                    },
                    series: [{
                        name: locale_submissions,
                        data: months_subcounts
                    }],
                    xaxis: {
                        categories: months_list,
                        type: 'category',
                        tooltip: {
                            enabled: false
                        }
                    },
                    legend: {
                        show: false
                    },
                    stroke: {
                        curve: 'smooth',
                        width: 3,
                    },
                    colors:['#EC4899'],
                    dataLabels: {
                        enabled: false
                    },
                    tooltip: {
                        enabled: true,
                        enabledOnSeries: [0],
                        x: {
                            show: false
                        },
                        y: {
                            formatter: undefined,
                            title: {
                                formatter: (seriesName) => locale_submissions,
                            },
                        },
                        marker: {
                            show: false
                        },
                    }
                }
                const chart = new ApexCharts($chart_submissions, options);
                chart.render();
            }
        }

        // CountUps
        let separator = ",";
        let decimal = ".";
        if(App.getLang() == "de") {
            separator = ".";
            decimal = ",";
        }
        const countUpElements = document.querySelectorAll('span.count-up');
        countUpElements.forEach($el => {
            const targetValue = parseInt($el.getAttribute('data-value'));
            let countUp = new CountUp($el, targetValue, { duration: 0.8, separator: separator, decimal: decimal, startVal: 0 });
            countUp.start();
        });

        // Kopierfunktion für Verbindungsdaten
        const btnsCopy = document.querySelectorAll("a.copy");
        btnsCopy.forEach($btnCopy => {

            const templateClipboard = new ClipboardJS($btnCopy, {
                text: function(trigger) {
                    const selectorStr = trigger.dataset.selectorId ?? null;

                    console.log(selectorStr);

                    if(selectorStr) {
                        const $ele = document.querySelector("#"+selectorStr);
                        if($ele) {
                            let text = $ele.textContent.trim();
                            return text;
                        }
                    }
                }
            });
            templateClipboard.on('success', event => {
                event.clearSelection();
                const msg = event.trigger.dataset.successmsg ?? "Copied!";
                new Notification().success(msg);
            });

        });

    }
}

// Initialisierung wenn DOM geladen
App.domready(()=>{
    if(document.querySelector('body').classList.contains('form-overview')) {
        new Page();
    }
});